import { IconButton } from '@ori-ui/components';
import { Visibility, VisibilityOff } from '@ori-ui/icons';
import { InputAdornment, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { Dispatch, FC, SetStateAction } from 'react';

const iconStyle = {
  fontSize: '32px',
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0),
}));

interface IPasswordToggleProps {
  isShowPassword: boolean;
  tabIndex?: number;
  setPasswordVisible: Dispatch<SetStateAction<boolean>>;
}

export const PasswordToggle: FC<IPasswordToggleProps> = (props) => {
  const { isShowPassword, tabIndex, setPasswordVisible } = props;
  const { getTestIdProps } = useTestId();

  const handleClick = () => setPasswordVisible(!isShowPassword);

  const icon = isShowPassword ? (
    <VisibilityOff
      sx={iconStyle}
      {...getTestIdProps('icon-visibilityOff')}
    />
  ) : (
    <Visibility
      sx={iconStyle}
      {...getTestIdProps('icon-visibilityOn')}
    />
  );

  return (
    <InputAdornment position="end">
      <StyledIconButton
        tabIndex={tabIndex}
        onClick={handleClick}
        variant="text"
        color="default"
      >
        {icon}
      </StyledIconButton>
    </InputAdornment>
  );
};
